<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>New Segment</h2>
        </div>
        <div slot="body">
            <div class="col-sm-12 py-3">
                <segments-form :segment="tempSegment"></segments-form>
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import segmentsForm from './segmentsForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                tempSegment: null
            }
        },
        created: function() {
            this.tempSegment = JSON.parse(JSON.stringify(this.getDefaultSegment)) // TODO: create it in store
        },
        computed: {
            ...mapGetters([
                'getDefaultSegment' // TODO: create it in store
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'createSegment' // TODO: create it in store
            ]),
            save: function() {
                this.createSegment(this.tempSegment).then( // TODO: create it in store
                    this.close()
                )
            },
            close: function() {
                this.closeModal();
            },
        },
        components: {
            Modal,
            segmentsForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// createSegment.vue?16afc583